/**
 * Collection of design tokens that define stacking order of positioned elements in relation to
 * their siblings, ensuring controlled layering.
 */ const zIndexes = {
    xs: 10,
    sm: 20,
    md: 30,
    lg: 40,
    xl: 50
};

export { zIndexes };
//# sourceMappingURL=z-indexes.js.map
